import { render } from "./viewProcurement.vue?vue&type=template&id=275fed2e&scoped=true"
import script from "./viewProcurement.vue?vue&type=script&lang=js"
export * from "./viewProcurement.vue?vue&type=script&lang=js"

import "./viewProcurement.vue?vue&type=style&index=0&id=275fed2e&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275fed2e"]])

export default __exports__